import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { SapC4CSink } from 'app/model/pipeline/copysink/sapc4c.copysink';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { stringIsNullOrEmpty } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapC4CSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBehavior: '*',
        writeBatchSize: '*',
        maxConcurrentConnections: '*',
        structure: '*',
        httpRequestTimeout: '*'
    }
})
export class SapC4CSinkAdapter extends CopySinkAdapter<SapC4CSink, Model.SapCloudForCustomerSink> {
    protected override async _toResource(model: SapC4CSink): Promise<Model.SapCloudForCustomerSink> {
        const result: Model.SapCloudForCustomerSink = {
            type: Metamodel.modelFor(SapC4CSink).name
        };
        result.writeBehavior = ValueAdapter.toResource(model, SapC4CSink.WRITE_BEHAVIOR);
        result.writeBatchSize = ValueAdapter.toResource(model, SapC4CSink.WRITE_BATCH_SIZE);
        CopySinkAdapter.maxConcurrentConnectionsToResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        result.httpRequestTimeout = ValueAdapter.toResource(model, SapC4CSink.HTTP_REQUEST_TIMEOUT);
        // clear out '' from resource, backend doesn't support ''
        if (stringIsNullOrEmpty(result.httpRequestTimeout)) {
            result.httpRequestTimeout = undefined;
        }
        return result;
    }

    protected override async _toModel(resource: Model.SapCloudForCustomerSink, owner: Activity): Promise<SapC4CSink> {
        const result = Owned.create<SapC4CSink>(Metamodel.modelFor(SapC4CSink), owner);
        ValueAdapter.toModel(result, SapC4CSink.WRITE_BATCH_SIZE, resource.writeBatchSize);

        // handle upper case and lower case
        let writeBehavior = resource.writeBehavior;
        if (writeBehavior && typeof writeBehavior === 'string') {
            const lowerCaseValue = writeBehavior.toLowerCase();
            switch (lowerCaseValue) {
                case writeBehaviorOptionValues.insert:
                    writeBehavior = writeBehaviorOptionValues.insert;
                    break;
                case writeBehaviorOptionValues.update:
                    writeBehavior = writeBehaviorOptionValues.update;
                    break;
                default:
                    break;
            }
        }
        ValueAdapter.toModel(result, SapC4CSink.WRITE_BEHAVIOR, writeBehavior);

        CopySinkAdapter.maxConcurrentConnectionsToModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        ValueAdapter.toModel(result, SapC4CSink.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        return result;
    }
}
